import { initTabSystem } from './utils/tabs';

document.addEventListener('DOMContentLoaded', function () {
  initTabSystem({
    tabsContainerSelector: '#contact-content-tabs',
    panelsContainerSelector: '#contact-content-panels',
    tabSelector: '.contact-content__tab',
    panelSelector: '.contact-content__panel',
    bgImageSelector: '#contact-content-bg-image',
    bgContainerSelector: '#contact-content-bg',
  });
});
